/**
 * Layer type constants.
 * Extend this list when adding new entity layers — zero engine changes required.
 */
export const LAYER_TYPES = {
  // Current pages
  USERS:         'users',
  HOSPITALS:     'hospitals',
  SNAKE_REPORTS: 'snakeReports',
  RESCUERS:      'rescuers',

  // Future layers (reserved — no engine changes needed)
  SNAKE_BITES:    'snakeBites',
  EMERGENCY:      'emergency',
  CONTROL_ROOM:   'controlRoom',
  DMO:            'dmo',
  FOREST_OFFICE:  'forestOffice',
  DISTRICT_OFFICE:'districtOffice',
};
